/* eslint-disable */
<template>
  <div class="rotate-wrapper">
    <button @click="getRuntime(0.5, 0.5)">测试按钮</button>
    <div class="rotate-content">
      <iframe
        ref="gameIframe"
        :src="gameSrc"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
    <!-- 提示没收到数据弹框 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" class="message-dialog">
      <div class="message-close" @click="dialogVisible = false">
        <img src="../../assets/img/message-close.png" alt="" />
      </div>
      <div class="message-box">
        <img src="../../assets/img/message-error.png" alt="" />
        <p>长时间未收到数据，请返回App重新连接蓝牙</p>
        <div class="message-btn">
          <p @click="dialogVisible = false">
            <img src="../../assets/img/message-cancel.png" alt="" />
            <span>取消</span>
          </p>
          <p @click="enterEsc">
            <img src="../../assets/img/message-btn.png" alt="" /><span
              >确认</span
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      webGameType: 0,
      gameSrc: "",
      id: "",
      // 保存模拟键盘方向键
      currentHeldKey: "",
      // 游戏是否开始
      isStart: false,
      noDataTimer: null,
      noDataTimeout: 10000, // 10秒无数据提醒
      isNoDataAlertShown: false,
      timerVersion: 0, // ✅ 新增唯一版本标记
      screenOrientation: 0,
      dialogVisible: false,
      iframeDoc: null,
      iframeWindow: null,
    };
  },
  async created() {},
  mounted() {},
  computed: {
    ...mapGetters(["key", "joystick", "language"]),
  },
  activated() {
    this.init();
    this.setupGyroDataReceiver();
  },
  deactivated() {
    window.__vueUnityHandler = null;
    if (this.noDataTimer) {
      clearTimeout(this.noDataTimer);
      this.noDataTimer = null;
    }
    if (this.startTimer) {
      clearTimeout(this.startTimer);
      this.startTimer = null;
    }
    this.timerVersion++;
    this.isStart = false;
  },
  watch: {
    key: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          if (newVal.indexOf("A") !== -1) {
            this.keyAGame();
          }
          if (newVal.indexOf("R") !== -1) {
            this.keyRGame();
          }
          if (newVal.indexOf("B") !== -1) {
            this.keyBGame();
          }
          if (newVal.indexOf("X") !== -1) {
            this.keyXGame();
          }
          if (newVal.indexOf("L") !== -1) {
            this.keyLGame();
          }
          if (newVal.indexOf("ZL") !== -1) {
            this.keyZLGame();
          }
          if (newVal.indexOf("ZR") !== -1) {
            this.keyZRGame();
          }
          if (newVal.indexOf("Y") !== -1) {
            this.keyYGame();
          }
        }
      },
      deep: true, // 必须加上才能触发对象/数组内部变动
    },
    joystick: {
      handler(newVal) {
        // console.log(newVal);
        this.moveMouse(newVal);
      },
      deep: true, // 必须加上才能触发对象/数组内部变动
    },
  },
  methods: {
    sendDataToUnity(value) {
      location.href = `uniwebview://vue-message?type=${value}`;
    },
    setupGyroDataReceiver() {
      window.__vueUnityHandler = (data) => {
        // console.log(data, 111);
        // this.test = data;
        try {
          const parsedData = typeof data === "string" ? JSON.parse(data) : data;
          if (parsedData.type === "sensorData") {
            this.resetNoDataTimer(); // 每次收到数据时重置定时器
            this.filterAndUpdateSensorData(parsedData.gamepadData);
          }
        } catch (error) {
          console.error("❌ 解析 UniApp 数据失败:", error);
        }
      };
      this.resetNoDataTimer(); // 回到首页重启监听
    },
    resetNoDataTimer() {
      // console.log("✅ resetNoDataTimer 被调用");
      this.timerVersion++;
      const currentVersion = this.timerVersion;
      // 清除之前定时器
      if (this.noDataTimer) {
        clearTimeout(this.noDataTimer);
        // console.log("🧹 清除了旧定时器");
      }
      this.isNoDataAlertShown = false; // 收到数据，重置提醒状态

      // 设置新定时器
      this.noDataTimer = setTimeout(() => {
        // console.log("⏰ 触发 showNoDataAlert 定时器");
        if (this.timerVersion !== currentVersion) {
          console.log("🚫 定时器版本已过期，跳过 alert");
          return; // 如果版本不一致，说明被新定时器覆盖
        }
        this.showNoDataAlert();
      }, this.noDataTimeout);
    },
    showNoDataAlert() {
      if (this.isNoDataAlertShown) return;
      this.isNoDataAlertShown = true;
      this.dialogVisible = true;
    },
    enterEsc() {
      this.sendDataToUnity("Close");
      this.dialogVisible = false;
    },
    filterAndUpdateSensorData(value) {
      this.$store.dispatch("delData", value);
    },
    // 初始化
    async init() {
      const query = this.$route.query;
      this.id = query.id;
      this.gameSrc = query.src;
      this.iframeOnload();
    },

    iframeOnload() {
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe?.contentWindow;
      const iframeDoc = iframeWindow?.document;
      if (!iframeWindow || !iframeDoc) {
        console.warn("iframe 或其 document 不可用");
        return;
      }
      this.iframeDoc = iframeDoc;
      this.iframeWindow = iframeWindow;
    },
    // A键相关
    async keyAGame() {
      console.log("触发A");
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe?.contentWindow;
      const iframeDoc = iframeWindow?.document;
      const startBtn = iframeDoc.querySelector(".ejs_start_button");
      console.log(startBtn, this.iframeDoc, window.EJS_Runtime);
      startBtn?.click();
    },
    // R键相关
    async keyRGame() {},
    // B键相关
    async keyBGame() {},
    // X键相关
    async keyXGame() {},
    // L键相关
    async keyLGame() {},
    // ZL相关
    async keyZLGame() {},
    // ZR相关
    async keyZRGame() {},
    // Y相关
    async keyYGame() {},
    // 摇杆控制
    moveMouse(value) {
      // 摇杆模拟键盘上下左右
      this.moveAction(value);
    },

    // 摇杆操作
    moveAction(value) {
      if (value.x < -0.5) {
        this.moveGame("ArrowLeft");
      } else if (value.x > 0.5) {
        this.moveGame("ArrowRight");
      }
      // } else {
      if (value.y < -0.5) {
        this.moveGame("ArrowDown");
      } else if (value.y > 0.5) {
        this.moveGame("ArrowUp");
      }
      if (Math.abs(value.x) < 0.5 && Math.abs(value.y) < 0.5) {
        this.releaseGameKey(this.currentHeldKey);
      }
    },
    getRuntime() {
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe?.contentWindow;
      const iframeDoc = iframeWindow?.document;
      const startBtn = iframeDoc.querySelector(".ejs_start_button");
      console.log(startBtn, this.iframeDoc, window.EJS_Runtime);
      startBtn?.click();
      // const iframe = this.$refs.gameIframe;
      // const iframeWindow = iframe?.contentWindow;
      // const iframeDoc = iframeWindow?.document;
      // if (!iframeWindow || !iframeDoc) {
      //   console.warn("iframe 或其 document 不可用");
      //   return;
      // }
      // console.log(iframeDoc, iframeDoc.querySelector(".ejs_start_button"));
      // const gameCanvas = iframeDoc.querySelector("canvas");
      // if (!gameCanvas) {
      //   console.warn("iframe 内部没有找到 <canvas> 元素");
      //   return;
      // }
      // console.log(gameCanvas);
      // const rect = gameCanvas.getBoundingClientRect();
      // const x = rect.left + rect.width * relativeX;
      // const y = rect.top + rect.height * relativeY;
      // // 可视化调试点
      // this.drawDebugDot(gameCanvas, relativeX, relativeY);
      // // 统一坐标
      // const touchX = x;
      // const touchY = y;
      // // 是否为触摸设备（简单判断）
      // const isTouchDevice =
      //   "ontouchstart" in window || navigator.maxTouchPoints > 0;
      // if (isTouchDevice) {
      //   try {
      //     const touch = new Touch({
      //       identifier: Date.now(),
      //       target: gameCanvas,
      //       clientX: touchX,
      //       clientY: touchY,
      //       pageX: touchX,
      //       pageY: touchY,
      //       screenX: touchX,
      //       screenY: touchY,
      //       radiusX: 2.5,
      //       radiusY: 2.5,
      //       rotationAngle: 10,
      //       force: 0.5,
      //     });
      //     const touchStartEvent = new TouchEvent("touchstart", {
      //       bubbles: true,
      //       cancelable: true,
      //       touches: [touch],
      //       targetTouches: [touch],
      //       changedTouches: [touch],
      //     });
      //     gameCanvas.dispatchEvent(touchStartEvent);
      //     setTimeout(() => {
      //       const touchEndEvent = new TouchEvent("touchend", {
      //         bubbles: true,
      //         cancelable: true,
      //         touches: [],
      //         targetTouches: [],
      //         changedTouches: [touch],
      //       });
      //       gameCanvas.dispatchEvent(touchEndEvent);
      //     }, 50);
      //   } catch (e) {
      //     console.warn("触发 TouchEvent 失败（可能是浏览器不允许构造）:", e);
      //   }
      // } else {
      //   // PC 模拟 mouse 点击事件
      //   const mouseDownEvent = new MouseEvent("mousedown", {
      //     bubbles: true,
      //     cancelable: true,
      //     clientX: touchX,
      //     clientY: touchY,
      //     button: 0,
      //   });
      //   gameCanvas.dispatchEvent(mouseDownEvent);
      //   setTimeout(() => {
      //     const mouseUpEvent = new MouseEvent("mouseup", {
      //       bubbles: true,
      //       cancelable: true,
      //       clientX: touchX,
      //       clientY: touchY,
      //       button: 0,
      //     });
      //     gameCanvas.dispatchEvent(mouseUpEvent);
      //     const clickEvent = new MouseEvent("click", {
      //       bubbles: true,
      //       cancelable: true,
      //       clientX: touchX,
      //       clientY: touchY,
      //       button: 0,
      //     });
      //     gameCanvas.dispatchEvent(clickEvent);
      //   }, 50);
      // }
      // if (!this.startTimer) {
      //   this.getState();
      // }
    },
    moveGame(keyChar) {
      const isHoldKey = [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
      ].includes(keyChar);

      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe?.contentWindow;
      const iframeDocument = iframe?.contentDocument || iframeWindow?.document;
      if (!iframeDocument) return;

      let keyCode = 0;
      let code = "";
      switch (keyChar) {
        case " ":
          keyCode = 32;
          code = "Space";
          break;
        case "i":
          keyCode = 73;
          code = "KeyI";
          break;
        case "k":
          keyCode = 75;
          code = "KeyK";
          break;
        case "j":
          keyCode = 74;
          code = "KeyJ";
          break;
        case "l":
          keyCode = 76;
          code = "KeyL";
          break;
        case "ArrowUp":
          keyCode = 38;
          code = "ArrowUp";
          break;
        case "ArrowDown":
          keyCode = 40;
          code = "ArrowDown";
          break;
        case "ArrowLeft":
          keyCode = 37;
          code = "ArrowLeft";
          break;
        case "ArrowRight":
          keyCode = 39;
          code = "ArrowRight";
          break;
        default:
          keyCode = keyChar.toUpperCase().charCodeAt(0);
          code = "Key" + keyChar.toUpperCase();
      }

      // 自动释放上一个方向键
      if (isHoldKey && this.currentHeldKey && this.currentHeldKey !== keyChar) {
        this.releaseGameKey(this.currentHeldKey);
      }

      // 发送新的 keydown
      const keydownEvent = new KeyboardEvent("keydown", {
        key: keyChar,
        code,
        keyCode,
        which: keyCode,
        bubbles: true,
        cancelable: true,
      });
      iframeDocument.dispatchEvent(keydownEvent);

      if (isHoldKey) {
        this.currentHeldKey = keyChar;
      } else {
        const keyupEvent = new KeyboardEvent("keyup", {
          key: keyChar,
          code,
          keyCode,
          which: keyCode,
          bubbles: true,
          cancelable: true,
        });
        setTimeout(() => {
          iframeDocument.dispatchEvent(keyupEvent);
        }, 100);
      }
      // this.getState();
      // if (!this.startTimer) {
      //   this.getState();
      // }
    },

    releaseGameKey(keyChar) {
      const iframe = this.$refs.gameIframe;
      const iframeWindow = iframe?.contentWindow;
      const iframeDocument = iframe?.contentDocument || iframeWindow?.document;
      if (!iframeDocument) return;

      let keyCode = 0;
      let code = "";
      switch (keyChar) {
        case "ArrowUp":
          keyCode = 38;
          code = "ArrowUp";
          break;
        case "ArrowDown":
          keyCode = 40;
          code = "ArrowDown";
          break;
        case "ArrowLeft":
          keyCode = 37;
          code = "ArrowLeft";
          break;
        case "ArrowRight":
          keyCode = 39;
          code = "ArrowRight";
          break;
      }

      const keyupEvent = new KeyboardEvent("keyup", {
        key: keyChar,
        code,
        keyCode,
        which: keyCode,
        bubbles: true,
        cancelable: true,
      });
      iframeDocument.dispatchEvent(keyupEvent);

      // 清除状态
      if (this.currentHeldKey === keyChar) {
        this.currentHeldKey = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* 横屏旋转容器 */
.rotate-wrapper {
  position: absolute;
  transform-origin: center center;
  overflow: hidden;
  // background: black;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  button {
    position: fixed;
    z-index: 10000;
    top: 10px;
    left: 10px;
  }
}
.landscape-mode {
  transform: rotate(-90deg);
  width: 100vh;
  height: 100vw;
}
.rotate-content {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.landscape-mode .rotate-content {
  width: 100vh;
  height: 100vw;
}
iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.landscape-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vh;
  height: 100vw;
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
}
.landscape-mode iframe {
  transform-origin: center center;
  border: none;
}
.rotate {
  position: absolute;
  z-index: 1000;
  left: 1%;
  top: 1%;
  img {
    width: 70px;
  }
}
.landscape-rotate {
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
  top: 85%;
}
.handle-box {
  position: absolute;
  z-index: 1000;
  left: 70%;
  top: 1%;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 20px 26px;
  border-radius: 48px;
}
.start-handle {
  top: 88%;
}
.landscape-handle {
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
  left: 1%;
}
.landscape-start {
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: top left;
  top: 0;
  left: 80%;
}
.handle-btn {
  font-weight: bold;
  font-size: 22px;
  color: #000000;
  line-height: 1;
  margin-left: 10px;
}

.mouse-circle {
  position: absolute;
  z-index: 1000;
  background: rgba(225, 57, 10, 0.8);
  width: 36px;
  height: 36px;
  border-radius: 100%;
  border: 6px solid rgba(52, 14, 241, 0.2);
}
</style>
